import { FC } from 'react';

import { useTranslation } from '@mint-lib/i18n';

import TabContentHeader from '../../components/TabContentHeader.jsx';
import { TabContentProps } from '../../types/singleFlow.js';
import Notifications from '../FlowForm/Notifications.jsx';

const NotificationsTab: FC<TabContentProps> = () => {
  const { t } = useTranslation('@myn/approval_v2');

  return (
    <div>
      <TabContentHeader
        title={t('Notifications')}
        description={t(
          'Enable reminders for your approvers and turn on automatic email delivery for approved flights.',
        )}
      />
      <div className="mt-4">
        <Notifications />
      </div>
    </div>
  );
};

export default NotificationsTab;
